module.exports = __webpack_public_path__ + "static/media/cancel.0c1e3844.svg";